'use strict';
angular.module('MW.Framework.ICMEmailService', 
    ['Configuration'])
    .service('ICMEmailService', [
        '$q', 
        '$http', 
        'EMAIL_DOMAIN', 
        function (
            $q, 
            $http, 
            EMAIL_DOMAIN
            ) {

    var emailServiceObj = {},
        contactRecipients = [],
        contactRecipientsQuery = {},
        mediaListRecipients = [];
            
        emailServiceObj.sender = {};
        function setSender(senderObject) {
            emailServiceObj.sender  = senderObject;
        }
        function getSender() {
            return emailServiceObj.sender;
        }

        function resetRecipients() {
            contactRecipients = [];
            mediaListRecipients = [];
            contactRecipientsQuery = {};
        }

        function setContactRecipients(contacts, sources) {
            contactRecipients = contacts.map(function(contact) {
                var email;
                const primary = contact.contactInfo.email.sort((a, b) => {
                    if (a.overlayMetadata && b.overlayMetadata || !a.overlayMetadata && !b.overlayMetadata) {
                        if ((!a.primary && b.primary)) {
                            return 1;
                        } else if (a.primary && !b.primary) {
                            return -1;
                        }
                    } else if (!a.overlayMetadata && b.overlayMetadata) {
                        return 1;
                    } else if (a.overlayMetadata && !b.overlayMetadata) {
                        return -1;
                    }
                    return 0;
                });
                email = primary[0];
                return {
                    id: contact.id,
                    name: contact.name.fullName,
                    firstName: contact.name.firstName,
                    lastName: contact.name.lastName,
                    email: email ? email.address : '',
                    private: contact.systemData.policies ? contact.systemData.policies.storage.private : true
                };
            });

            if (sources && sources.length > 0) {
                contactRecipients = contactRecipients.concat(sources.map(function(source) {
                    return {
                        id: null,
                        name: source.name.fullName || source.name,
                        email: source.email || source.emails[0].address,
                        private: true
                    };
                }));
            }
        }

        function getContactRecipients() {
            return contactRecipients;
        }

        function setSourceRecipients(sources) {
            contactRecipients = sources.map(function(source) {
                return {
                    id: null,
                    name: source.name,
                    email: source.email,
                    private: true
                };
            });
        }

        function setContactRecipientsQuery(query) {
            contactRecipientsQuery = {
                mediaListIds: query.mediaListIds,
                q: query.q,
                pageSize: query.pageSize
            };
        }

        function getContactRecipientsQuery() {
            return contactRecipientsQuery;
        }

        function setMediaListRecipients(mediaLists) {
            mediaListRecipients = mediaLists.map(function(mediaList) {
                return {
                    id: mediaList.id,
                    name: mediaList.name
                };
            });
        }
    
        function getMediaListRecipients() {
            return mediaListRecipients;
        }

        function getIcmApprovedSenders() {
            var defer = $q.defer(),
            config = {
                headers: {
                    'X-Client-Name': 'icm-web'
                }
            };

            $http.get(EMAIL_DOMAIN + '/email/approvedSender?getCombinedStatus=false', config)
                .then(function (response) {
                    var senders = response.data;
                    if(Array.isArray(senders) && senders.length) {
                        let isApproved = senders.filter((sender => {
                            return sender.is_approved;
                        }));
                        defer.resolve(isApproved);
                    } 
                    else {
                        defer.resolve([]);
                    }
                })
                .catch(function () {
                    defer.reject();
                });
            return defer.promise;
        }

        return {
            setSender: setSender,
            getSender: getSender,
            resetRecipients: resetRecipients,
            setContactRecipients: setContactRecipients,
            setSourceRecipients: setSourceRecipients,
            getContactRecipients: getContactRecipients,
            setContactRecipientsQuery: setContactRecipientsQuery,
            getContactRecipientsQuery: getContactRecipientsQuery,
            setMediaListRecipients: setMediaListRecipients,
            getMediaListRecipients: getMediaListRecipients,
            getIcmApprovedSenders: getIcmApprovedSenders
        };
}]);